import { render, staticRenderFns } from "./ProductsListItem.vue?vue&type=template&id=1e4f32b2"
import script from "./ProductsListItem.vue?vue&type=script&lang=js"
export * from "./ProductsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports